import { useAppSelector } from "@/lib/redux/hooks"
import SearchingAirportItem from "./SearchingAirportItem"
import { FC, useMemo } from "react"
import { TypeAirport } from "@/lib/redux/features/flight/type"
import { useAirports } from "@/hooks/flight/useAirports"

type PlacementsByCountryProps = {
  countryCode: string,
  onChange?: (airport?: TypeAirport) => void
}

const PlacementsByCountry: FC<PlacementsByCountryProps> = ({ countryCode, onChange }) => {
  const airportsData = useAirports()
  const mappingCountriesAirports = useAppSelector(state => state.flight.mappingCountriesAirports)
  const airports = useMemo(() => {
    const airportCodes = mappingCountriesAirports[countryCode] || []
    return airportCodes.map(code => airportsData[code])

  }, [airportsData, mappingCountriesAirports, countryCode])

  return (
    <>
      {airports.map((airport) => (
        <SearchingAirportItem
          onChange={onChange}
          key={airport.code}
          airport={airport}
        />
      ))}
    </>
  )
}

export default PlacementsByCountry